import React, {Component} from 'react';

import * as func from "../../../../../../utils/functions";

import {MESSAGE, EDIT_MODE} from "../../../../../../wpconfig"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink} from "@fortawesome/free-solid-svg-icons";

class rankingItem extends Component {
	constructor(props) {
		super(props);

		const r = JSON.parse(JSON.stringify(this.props.record));

		this.state = {
			isEdit: r.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : r,
      ranking: {}
		}
  }

  componentDidMount() {
    this.setState({
      ranking : this.props.record
    })
	}

	change = (e) => {
    const { record } = this.props
    record[e.target.name] = e.target.value
		console.log(e.target.name)
		console.log(e.target.value)
		this.props.onUpdate(this.props.arrIndex, record, false);
    // this.setState({
    //   ranking : ranking
    // })
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

		console.log(this.props.record)

		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.state.ranking.ranking_id) {
				func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.indicator_id + "/ranking/update", this.props.record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						// this.setState({
						// 	ranking : JSON.parse(JSON.stringify(this.props.record))
						// })
						// this.props.showMessage('수정 되었습니다.');
					} else {
						// this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
          // console.log(response)
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = this.props.record;
				// if (this.source_id.value === '') {
				// 	this.source_id.focus();
				// } else {
					delete record.is_edit;
					func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.indicator_id + "/ranking/insert", record).then((response) => {
						// console.log(response)
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							// this.props.showMessage('추가 되었습니다.');
						} else {
							// this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				// }
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (event) => {
		// event.preventDefault()

    // if (this.state.isEdit) {
    //   Object.keys(this.state.ranking).map((key) => {
    //     if(this[key]) {
    //       this[key].value = this.state.ranking[key]
    //     }
    //   })
    // }

    // this.setState({'isEdit': EDIT_MODE.SHOW});
		event.preventDefault()

		const record = this.props.record;
		if (record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.setState({'isEdit': EDIT_MODE.SHOW});
				this.props.onUpdate(this.props.arrIndex, func.deepClone(this.state.record), true);
			} else {
				if (confirm('(' + record.category_code + ')' + record.category_name + '를 ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.indicator_id + "/ranking/delete", record).then((response) => {
						if (response.code === 'ok') {
							// this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							// this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	};

	render() {
    const { record } = this.props

		// console.log(record)

		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr className="list-row">
						<td>{ record.category_code }</td>
						<td>{ record.category_name }</td>
						<td>{ record.edition }</td>
						<td>{ record.ranking_type }</td>
						<td>{ record.category_count }</td>
						<td>{ record.ranking }</td>
						<td>{ record.percent }%</td>
						<td>{ record.percentile }%</td>
						<td>{ record.quartile }</td>
						{
							record.indicator_type == "kci" ?
								<td>{ record.category_impact }</td> : ''
						}
						<td className="column-action">
							<div className="btn-group">
								<button type="button" className="btn btn-outline-success btn-sm" onClick={this.onEditSave}>수정</button>
								<button type="button" className="btn btn-outline-danger btn-sm" onClick={this.onCloseDelete}>삭제</button>
							</div>
						</td>
					</tr>
					:
					<tr className="list-row">
						<td>
							<input type="text" name="category_code"
							       className="form-control-sm large-text" 
                     defaultValue={record.category_code}
										 placeholder="코드"
							       onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="category_name"
							       className="form-control-sm large-text" 
                     defaultValue={record.category_name}
										 placeholder="카테고리 명"
							       onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="edition"
								   className="form-control-sm large-text"
								   defaultValue={record.edition}
								   placeholder="Edition"
								   onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="ranking_type"
								   className="form-control-sm large-text"
								   defaultValue={record.ranking_type}
								   placeholder="랭킹유형"
								   onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="category_count"
							       className="form-control-sm large-text" 
                     defaultValue={record.category_count}
										 placeholder="저널 수"
							       onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="ranking"
							       className="form-control-sm large-text" 
                     defaultValue={Number(record.ranking)}
										 placeholder="랭킹"
							       onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="percent"
							       className="form-control-sm large-text" 
                     defaultValue={record.percent}
										 placeholder="상위퍼센트"
							       onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="percentile"
								   className="form-control-sm large-text"
								   defaultValue={record.percentile}
								   onKeyUp={this.change} />
						</td>
						<td>
							<input type="text" name="quartile"
								   className="form-control-sm large-text"
								   defaultValue={record.quartile}
								   onKeyUp={this.change} />
						</td>
						{
							record.indicator_type == "kci" ?
								<td>
									<input type="text" name="category_impact"
										   className="form-control-sm large-text"
										   defaultValue={record.category_impact}
										   onKeyUp={this.change} />
								</td> : ''
						}
						<td>
								<div className="btn-group float-right">
									<button type="button" className="btn btn-outline-primary btn-sm" onClick={this.onEditSave}>저장</button>
									<button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.onCloseDelete}>닫기</button>
								</div>
						</td>
					</tr>
				}
			</>
		)
	}
}

export default rankingItem;